<div class="route-content-top">
  <ol class="breadcrumbs">
      <li *ngIf="breadcrumbs.length > 0">
          <ng-container>
              <a href="#/"><mat-icon class="customIcon">home</mat-icon></a>
              <span style="vertical-align: sub;"> » </span>
          </ng-container>
      </li>
      <li *ngFor="let breadcrumb of breadcrumbs; index as i; last as isLast">
        <ng-container>
          <a style="text-decoration:none;vertical-align: sub" class="breadcrumb-current-route" [class.breadcrumb-history-link]="!isLast" [href]="[breadcrumb.url]">
              {{breadcrumb.label | translate}}
          </a>
          <span style="vertical-align: sub;" *ngIf="!isLast"> » </span>
        </ng-container>
      </li>
    </ol>
  </div>